import { Box } from "@mui/material";
import EquipmentDropdown from "../../../Inputs/EquipmentDropdown/EquipmentDropdown";
import EquipmentFilterButtons from "../EquipmentFilterButtons/EquipmentFilterButtons";
import EquipmentTableCard from "../EquipmentTableCard/EquipmentTableCard";

const EquipmentSection = ({
  equipmentsOptions = [],
  clickAllEquipment,
  handleClickedEquipment,
  setSelectedEquipment,
  clickedEquipment,
  removeAllClickedEquipment,
  selectedEquipment,
  fixedHeaderContent,
  tableBodyRowContent,
  processedEquipment,
  equipmentInputs,
  handleSuccessAdd,
  isEquipmentLoading = false,
  openEquipmentExportModal
}) => {
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <EquipmentFilterButtons
          options={equipmentsOptions}
          selectedEquipment={selectedEquipment}
          clickedEquipment={clickedEquipment}
          handleClickEquipment={handleClickedEquipment}
          addAllClickedEquipment={clickAllEquipment}
          removeAllClickedEquipment={removeAllClickedEquipment}
          color="#1B3665"
        />
        <EquipmentDropdown
          options={equipmentsOptions}
          selectedEquipment={selectedEquipment}
          handleSelectionChange={(value) => {
            setSelectedEquipment(value);
          }}
          borderColor="#1B3665"
          iconColor="#1B3665"
          textColor="#1B3665"
        />
      </Box>
      <EquipmentTableCard
        textColor="#1B3665"
        addBtnBackground="#B6CFF1"
        fixedHeaderContent={fixedHeaderContent}
        tableBodyRowContent={tableBodyRowContent}
        processedEquipment={processedEquipment}
        equipmentInputs={equipmentInputs}
        handleAddEquipmentSuccess={handleSuccessAdd}
        isLoading={isEquipmentLoading}
        openEquipmentExportModal={openEquipmentExportModal}
      />
    </Box>
  )
};

export default EquipmentSection;
